<ng-container *transloco="let t">
    <div>
        <app-user-details-data [userDetails]="user" [isBasicDataCollapsed]="false" [isRaceDataCollapsed]="false"
            [competitor]="isCompetitor()" [basicDataTitle]=" t('app.user.profile.basic.data')"
            [raceDataTitle]=" t('app.user.profile.race.settings')"/>
    </div>
  <app-action-buttons-row [saveVisible]="false"/>
</ng-container>
